import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const LabelKindEye = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx={8} cy={8} r={8} fill="#4BB24E" />
            <path
                d="M3.41663 7.99996C3.41663 7.99996 5.08329 4.66663 7.99996 4.66663C10.9166 4.66663 12.5833 7.99996 12.5833 7.99996C12.5833 7.99996 10.9166 11.3333 7.99996 11.3333C5.08329 11.3333 3.41663 7.99996 3.41663 7.99996Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.99996 9.24996C8.69031 9.24996 9.24996 8.69031 9.24996 7.99996C9.24996 7.3096 8.69031 6.74996 7.99996 6.74996C7.3096 6.74996 6.74996 7.3096 6.74996 7.99996C6.74996 8.69031 7.3096 9.24996 7.99996 9.24996Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'Label'
);
export default LabelKindEye;
